<script lang="ts">
const __DsBlock = {
	category: 'basic',
	events: [
		{
			name: 'action',
			payload: [],
		},
	],
	options: [
		{
			name: 'title',
			label: '$t:blocks.common.props.title',
		},
		{
			name: 'description',
			label: '$t:blocks.common.props.description',
		},
		{
			name: 'icon',
			label: '$t:blocks.common.props.icon',
			block: BuiltinBlockIds.InputIcon,
			nullable: true,
		},
		{
			kind: FormSchemaKind.Presentational,
			block: BuiltinBlockIds.FormSeparator,
			props: {
				label: '$t:blocks.empty.props.action',
			},
		},
		{
			name: 'actionLabel',
			label: '$t:blocks.empty.props.action_label',
		},
		{
			name: 'actionIcon',
			label: '$t:blocks.empty.props.action_icon',
			block: BuiltinBlockIds.InputIcon,
			nullable: true,
		},
	],
	hidden: blockContextIsContentPage,
}
</script>
<script lang="ts" setup>
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { blockContextIsContentPage, defineBlock, FormSchemaKind, useBlockInEditorContext } from '#layers/block-engine/public';
import { useTranslationUtils } from '#layers/i18n/public';

withDefaults(defineProps<{
	icon?: string;
	title?: string;
	description?: string;
	actionLabel?: string | null;
	actionIcon?: string;
}>(), {
	icon: 'lucide:circle-slash',
	title: '$t:blocks.empty.default_title',
	description: '$t:blocks.empty.default_description',
	actionLabel: null,
	actionIcon: 'lucide:plus',
});

defineEmits<{
	action: [];
}>();

;

const { isPreview } = useBlockInEditorContext();
const { translateString } = useTranslationUtils();
</script>

<template>
	<DEmpty
		:icon
		:title="translateString(isPreview ? '$t:organization.workspaces.listing.empty.title' : title)"
		:description="translateString(isPreview ? '$t:organization.workspaces.listing.empty.description' : description)"
		:action-button-label="actionLabel ? translateString(actionLabel) : undefined"
		:action-button-icon="actionIcon"
		@action="$emit('action')"
	/>
</template>
